import { observer, useLocalObservable } from "mobx-react";
import TopTabs from "../HomePage/component/TopTabs";
import React, { useEffect } from "react";
import MyPageStore from "./store/MyPageStore";
import { useRootStore } from "store/StoreContextProvider";
import { Divider, Grid } from "@mui/material";
import HeaderContent from "component/layout/HeaderContent";
import TopHeader from "pages/HomePage/component/TopHeader";
import MyPageScoreDetailTop from "./component/MyPageScoreDetail/MyPageScoreDetailTop";
import MyPageScoreDetailBody from "./component/MyPageScoreDetail/MyPageScoreDetailBody";
import MyPageTopTabs from "./component/MyPageScoreDetail/MyPageTopTabs";
import MyPageDrawer from "./component/MyPageScoreDetail/MyPageDrawer";

function MyPageScoreDetail() {
  const { headerStore } = useRootStore();
  const [isDrawerVisible, setIsDrawerVisible] = React.useState<boolean>(false);

  const pageStore = useLocalObservable(() => new MyPageStore());

  useEffect(() => {
    headerStore.setPageTitle("내 평점");
  }, [headerStore]);

  const handleClickTuneIcon = () => {
    setIsDrawerVisible(true);
    pageStore.setFilterValue("");
  };

  return (
    <HeaderContent>
      <TopHeader isBackIcon isTuneIcon onClickTuneIcon={handleClickTuneIcon} />
      <MyPageScoreDetailTop pageStore={pageStore} />
      <MyPageTopTabs pageStore={pageStore} />
      <MyPageScoreDetailBody pageStore={pageStore} />
      <MyPageDrawer
        isDrawerVisible={isDrawerVisible}
        setIsDrawerVisible={setIsDrawerVisible}
        pageStore={pageStore}
      />
    </HeaderContent>
  );
}

export default observer(MyPageScoreDetail);
